export default[
  {value:'newest', label:'Mais recentes'},
  {value:'oldest', label:'Mais antigos'},
  {value:'alphabetical', label:'Ordem alfabética'}
]
